import { Box, Typography } from '@mui/material';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import dayjs from 'dayjs';
import { variants } from '../../../../variants/variants';

export default function DatePicker ({ handleDateChange }) {
  const handleAccept = (value, context) => {
    let selectedDate = dayjs(value).toDate();
    handleDateChange(selectedDate);
  };
  return (
    <Box sx={{ mt: 1 }}>
      <Typography sx={{ fontSize: variants.BODY, color: variants.typography.inactive.hover, mb: 1 }}>
        Select date and time of jury meeting:
      </Typography>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DateTimePicker disablePast orientation='landscape' onAccept={handleAccept} />
      </LocalizationProvider>
    </Box>
  );
}
